/* Modeville return request form.
   Progressive enhancement over Shopify's native contact form: builds item rows, validates,
   writes a structured message into contact[body], creates a reference, and prevents duplicates.
   Nothing here talks to any other service. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mv-rr]');
  if (!root) return;

  var MAIL = root.getAttribute('data-mail') || '';
  var MAX_ITEMS = 10;
  var KEY_LAST = 'mvRr:last';
  var KEY_DRAFT = 'mvRr:draft';
  var KEY_SENT = 'mvRr:sent';
  var REASONS = [
    ['Changed my mind', false],
    ['Too small', false],
    ['Too large', false],
    ['Not as described or pictured', true],
    ['Faulty', true],
    ['Damaged on arrival', true],
    ['Incorrect item received', true],
    ['Other (please explain in details)', false]
  ];

  function store(kind, key, val) {
    try {
      var s = kind === 'local' ? window.localStorage : window.sessionStorage;
      if (val === undefined) { var r = s.getItem(key); return r ? JSON.parse(r) : null; }
      if (val === null) { s.removeItem(key); return; }
      s.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function esc(str) { return String(str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  var form = $('#mv-rr-form');
  var body = $('[data-mv-rr-body]');
  var success = $('[data-mv-rr-success]');

  /* ---------- Success state ---------- */
  if (success) {
    var last = store('session', KEY_LAST);
    if (last && last.ref) {
      $('[data-mv-rr-ref]', success).textContent = last.ref;
      $('[data-mv-rr-ref-wrap]', success).hidden = false;
      var sum = $('[data-mv-rr-summary]', success);
      var html = '<h3 class="mv-rr__sub">What you sent</h3><dl class="mv-rr__dl">';
      html += '<dt>Order</dt><dd>' + esc(last.order || '') + '</dd>';
      (last.items || []).forEach(function (it, i) {
        html += '<dt>Item ' + (i + 1) + '</dt><dd>' + esc(it.name) + ' &middot; ' + esc(it.colour) + ' &middot; size ' + esc(it.size) + ' &middot; qty ' + esc(it.qty) + '<br><span class="mv-rr__muted">Reason: ' + esc(it.reason) + '</span></dd>';
      });
      html += '</dl>';
      sum.innerHTML = html; sum.hidden = false;
      if (last.photoRelevant) {
        var pl = $('[data-mv-rr-photo-line]', success); pl.hidden = false;
        var gen = $('[data-mv-rr-photo-generic]', success); if (gen) gen.hidden = true;
        var link = $('[data-mv-rr-photo-link]', success);
        link.href = 'mailto:' + MAIL + '?subject=' + encodeURIComponent('Photos for return request ' + last.ref) + '&body=' + encodeURIComponent('Reference: ' + last.ref + '\nOrder number: ' + (last.order || '') + '\n\n(Please attach your photos to this email.)');
      }
    }
    store('session', KEY_DRAFT, null);
    var pr = $('[data-mv-rr-print]', success);
    if (pr) pr.addEventListener('click', function () { window.print(); });
    var again = $('[data-mv-rr-again]', success);
    if (again) again.addEventListener('click', function () { store('session', KEY_LAST, null); });
    window.setTimeout(function () { try { success.focus({ preventScroll: false }); success.scrollIntoView({ block: 'start' }); } catch (e) {} }, 50);
    return; /* nothing else to enhance once sent */
  }

  /* ---------- Item rows ---------- */
  var itemsWrap = $('[data-mv-rr-items]');
  var addBtn = $('[data-mv-rr-add]');
  var nsBox = $('#mv-rr-items-ns'); /* only exists inside <noscript>, never parsed when JS runs */

  function reasonOptions() {
    var o = '<option value="">Choose a reason</option>';
    REASONS.forEach(function (r) { o += '<option value="' + esc(r[0]) + '">' + esc(r[0]) + '</option>'; });
    return o;
  }

  function rowHtml(n) {
    return '' +
      '<fieldset class="mv-rr__item" data-item>' +
      '<legend class="mv-rr__item-title" data-item-title>Item ' + n + '</legend>' +
      '<div class="mv-rr__grid">' +
      '<div class="mv-rr__field mv-rr__field--wide"><label for="mv-rr-i' + n + '-name">Item name <span class="mv-rr__req">required</span></label>' +
      '<input id="mv-rr-i' + n + '-name" type="text" data-f="name" maxlength="120" autocomplete="off" data-required data-label="Item name" aria-describedby="mv-rr-i' + n + '-name-hint">' +
      '<p class="mv-rr__hint" id="mv-rr-i' + n + '-name-hint">As shown in your order confirmation.</p>' +
      '<p class="mv-rr__err" data-err-for="mv-rr-i' + n + '-name" hidden></p></div>' +
      '<div class="mv-rr__field"><label for="mv-rr-i' + n + '-colour">Colour <span class="mv-rr__req">required</span></label>' +
      '<input id="mv-rr-i' + n + '-colour" type="text" data-f="colour" maxlength="40" autocomplete="off" data-required data-label="Colour">' +
      '<p class="mv-rr__err" data-err-for="mv-rr-i' + n + '-colour" hidden></p></div>' +
      '<div class="mv-rr__field"><label for="mv-rr-i' + n + '-size">Size <span class="mv-rr__req">required</span></label>' +
      '<input id="mv-rr-i' + n + '-size" type="text" data-f="size" maxlength="30" autocomplete="off" data-required data-label="Size" aria-describedby="mv-rr-i' + n + '-size-hint">' +
      '<p class="mv-rr__hint" id="mv-rr-i' + n + '-size-hint">For example S/M, Medium or One size.</p>' +
      '<p class="mv-rr__err" data-err-for="mv-rr-i' + n + '-size" hidden></p></div>' +
      '<div class="mv-rr__field mv-rr__field--qty"><label for="mv-rr-i' + n + '-qty">Quantity <span class="mv-rr__req">required</span></label>' +
      '<input id="mv-rr-i' + n + '-qty" type="number" inputmode="numeric" min="1" max="20" step="1" value="1" data-f="qty" data-required data-label="Quantity">' +
      '<p class="mv-rr__err" data-err-for="mv-rr-i' + n + '-qty" hidden></p></div>' +
      '<div class="mv-rr__field mv-rr__field--wide"><label for="mv-rr-i' + n + '-reason">Reason <span class="mv-rr__req">required</span></label>' +
      '<select id="mv-rr-i' + n + '-reason" data-f="reason" data-required data-label="Reason">' + reasonOptions() + '</select>' +
      '<p class="mv-rr__err" data-err-for="mv-rr-i' + n + '-reason" hidden></p>' +
      '<p class="mv-rr__hint mv-rr__fault-hint" data-fault-hint hidden>Photos are required for this reason, or your return request will be rejected. See &ldquo;Photos&rdquo; below.</p></div>' +
      '</div>' +
      '<button type="button" class="mv-rr__remove" data-remove hidden>Remove this item</button>' +
      '</fieldset>';
  }

  function rows() { return $all('[data-item]', itemsWrap); }

  function renumber() {
    var list = rows();
    list.forEach(function (row, i) {
      var t = $('[data-item-title]', row); if (t) t.textContent = 'Item ' + (i + 1);
      var rm = $('[data-remove]', row); if (rm) rm.hidden = list.length < 2;
    });
    addBtn.hidden = false;
    addBtn.disabled = list.length >= MAX_ITEMS;
    addBtn.textContent = list.length >= MAX_ITEMS ? 'Maximum of ' + MAX_ITEMS + ' items' : '+ Add another item';
  }

  var counter = 0;
  function addRow(focus) {
    if (rows().length >= MAX_ITEMS) return null;
    counter += 1;
    var tmp = document.createElement('div');
    tmp.innerHTML = rowHtml(counter);
    var row = tmp.firstChild;
    itemsWrap.appendChild(row);
    renumber();
    if (focus) { var f = $('input', row); if (f) f.focus(); }
    return row;
  }

  itemsWrap.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (!rm) return;
    var row = rm.closest('[data-item]');
    var list = rows();
    if (list.length < 2) return;
    var idx = list.indexOf(row);
    row.parentNode.removeChild(row);
    renumber();
    var next = rows()[Math.max(0, idx - 1)];
    var f = next && $('input', next); if (f) f.focus();
    syncPhotoHints();
  });
  addBtn.addEventListener('click', function () { addRow(true); });

  /* ---------- Photos note ---------- */
  function faultySelected() {
    return rows().some(function (r) {
      var v = $('[data-f=reason]', r).value;
      return REASONS.some(function (x) { return x[0] === v && x[1]; });
    });
  }
  function syncPhotoHints() {
    var f = faultySelected();
    $all('[data-item]', itemsWrap).forEach(function (r) {
      var v = $('[data-f=reason]', r).value;
      var isF = REASONS.some(function (x) { return x[0] === v && x[1]; });
      $('[data-fault-hint]', r).hidden = !isF;
    });
    var ph = $('[data-mv-rr-photos]');
    ph.classList.toggle('is-highlight', f);
  }
  itemsWrap.addEventListener('change', syncPhotoHints);

  /* ---------- Validation ---------- */
  var errBox = $('[data-mv-rr-errors]');
  function setErr(input, msg) {
    var id = input.id;
    var p = $('[data-err-for="' + id + '"]');
    if (!p) return;
    if (msg) {
      p.textContent = msg; p.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      var d = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (d.indexOf(p.id || (p.id = id + '-err')) < 0) { d.push(p.id); input.setAttribute('aria-describedby', d.join(' ')); }
    } else {
      p.hidden = true; p.textContent = '';
      input.removeAttribute('aria-invalid');
    }
  }
  var NOUN = { 'Your name': 'your name', 'Email': 'your email address', 'Order number': 'your order number', 'Item name': 'the item name', 'Colour': 'the colour', 'Size': 'the size', 'Quantity': 'the quantity' };
  function validate() {
    var problems = [];
    var firstBad = null;
    var all = $all('[data-required]', form);
    all.forEach(function (el) {
      var label = el.getAttribute('data-label') || 'This field';
      var msg = '';
      if (el.type === 'checkbox') { if (!el.checked) msg = 'Please tick the box to confirm you understand.'; }
      else {
        var v = (el.value || '').trim();
        if (!v) msg = (el.tagName === 'SELECT' ? 'Please choose a reason.' : 'Please enter ' + (NOUN[label] || label.toLowerCase()) + '.');
        else if (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = 'Please enter a valid email address, for example name@example.com.';
        else if (el.type === 'number') {
          var n = Number(v);
          if (!(n >= 1 && n <= 20) || Math.floor(n) !== n) msg = 'Please enter a quantity from 1 to 20.';
        } else if (el.id === 'mv-rr-order' && !/\d/.test(v)) msg = 'Your order number contains digits, for example #1234.';
      }
      setErr(el, msg);
      if (msg) { problems.push({ el: el, text: (el.type === 'checkbox' ? 'Confirmation: ' : label + ': ') + msg }); if (!firstBad) firstBad = el; }
    });
    var photosBox = $('#mv-rr-photos-yes');
    if (photosBox) {
      var pm = '';
      if (faultySelected() && !photosBox.checked) pm = 'Please tick the box to confirm you will email photos. They are required for a faulty, damaged, incorrect or not-as-described item, and your return request will be rejected without them.';
      setErr(photosBox, pm);
      if (pm) { problems.push({ el: photosBox, text: 'Photos: ' + pm }); if (!firstBad) firstBad = photosBox; }
    }
    var recv = $('#mv-rr-received');
    if (recv && recv.value) {
      var d = new Date(recv.value + 'T00:00:00'); var now = new Date(); now.setHours(23, 59, 59, 999);
      var m = '';
      if (isNaN(d.getTime())) m = 'Please enter a valid date.';
      else if (d > now) m = 'The arrival date cannot be in the future.';
      setErr(recv, m);
      if (m) { problems.push({ el: recv, text: 'Date: ' + m }); if (!firstBad) firstBad = recv; }
    }
    if (problems.length) {
      errBox.innerHTML = '<strong>Please fix ' + (problems.length === 1 ? 'this' : 'these ' + problems.length + ' things') + ' before sending:</strong><ul>' +
        problems.map(function (p) { return '<li><a href="#' + p.el.id + '">' + esc(p.text) + '</a></li>'; }).join('') + '</ul>';
      errBox.hidden = false;
      errBox.focus();
      errBox.scrollIntoView({ block: 'center' });
    } else { errBox.hidden = true; errBox.innerHTML = ''; }
    return !problems.length;
  }
  errBox.addEventListener('click', function (e) {
    var a = e.target.closest('a'); if (!a) return;
    e.preventDefault();
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (t) { t.scrollIntoView({ block: 'center' }); t.focus(); }
  });
  form.addEventListener('input', function (e) { if (e.target.hasAttribute && e.target.getAttribute('aria-invalid')) { if ((e.target.value || e.target.checked)) setErr(e.target, ''); } });

  /* ---------- Reference, message body, duplicates ---------- */
  function makeRef() {
    var d = new Date();
    var ymd = String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
    var chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789', out = '';
    var arr = new Uint32Array(4);
    (window.crypto || window.msCrypto).getRandomValues(arr);
    for (var i = 0; i < 4; i++) out += chars[arr[i] % chars.length];
    return 'MVR-' + ymd + '-' + out;
  }
  function collect() {
    return rows().map(function (r) {
      return {
        name: $('[data-f=name]', r).value.trim(),
        colour: $('[data-f=colour]', r).value.trim(),
        size: $('[data-f=size]', r).value.trim(),
        qty: $('[data-f=qty]', r).value.trim(),
        reason: $('[data-f=reason]', r).value
      };
    });
  }
  function fingerprint(order, items) {
    return (order.toLowerCase().replace(/[^a-z0-9]/g, '') + '|' + items.map(function (i) { return [i.name, i.colour, i.size, i.qty].join('~').toLowerCase(); }).sort().join('|'));
  }
  function buildBody(ref, items, order, photosYes) {
    var name = $('#mv-rr-name').value.trim(), email = $('#mv-rr-email').value.trim();
    var recv = $('#mv-rr-received').value, details = $('#mv-rr-details').value.trim();
    var L = [];
    L.push('RETURN REQUEST - AWAITING REVIEW (not approved)');
    L.push('Reference: ' + ref);
    L.push('Order number: ' + order);
    L.push('Customer: ' + name + ' <' + email + '>');
    L.push('Order arrived (customer stated): ' + (recv || 'not given'));
    L.push('');
    L.push('Items:');
    items.forEach(function (it, i) { L.push('  ' + (i + 1) + '. ' + it.name + ' | Colour: ' + it.colour + ' | Size: ' + it.size + ' | Qty: ' + it.qty + ' | Reason: ' + it.reason); });
    L.push('');
    var needPhotos = items.some(function (i) { return REASONS.some(function (x) { return x[0] === i.reason && x[1]; }); });
    L.push('Photos: ' + (needPhotos ? 'REQUIRED for this request (faulty, damaged, incorrect or not as described). Customer was told to send photos quoting the reference' + (photosYes ? ' and confirmed they will.' : '.') + ' If no photos are received, reject the request (customer was told it would be rejected).' : 'not required (no faulty, damaged, incorrect or not-as-described items).'));
    L.push('Details: ' + (details || 'none'));
    L.push('');
    L.push('Submitted via the website return request form on ' + new Date().toISOString() + '.');
    L.push('Check name, email and order number against the order before approving.');
    return L.join('\n');
  }

  var bodyField = $('#mv-rr-body');
  bodyField.setAttribute('name', 'contact[body]');
  var sendBtn = $('[data-mv-rr-send]');
  var submitting = false;
  var dupAcknowledged = false;

  function restoreDraft() {
    var d = store('session', KEY_DRAFT);
    if (!d) return false;
    ['name', 'email', 'order', 'received', 'details'].forEach(function (k) {
      var el = $('#mv-rr-' + k); if (el && d[k] && !el.value) el.value = d[k];
    });
    (d.items || []).forEach(function (it, i) {
      var row = i === 0 ? rows()[0] : addRow(false);
      if (!row) return;
      Object.keys(it).forEach(function (k) { var f = $('[data-f=' + k + ']', row); if (f) f.value = it[k]; });
    });
    var ph = $('#mv-rr-photos-yes'); if (ph) ph.checked = !!d.photos;
    return true;
  }

  addRow(false);
  var hadServerErrors = $('[data-mv-rr-server-errors]');
  if (hadServerErrors) {
    /* The send failed on the server, so forget the "already sent" record for it and bring the answers back. */
    var failed = store('session', KEY_LAST), list0 = store('local', KEY_SENT) || [];
    if (failed && failed.ref) store('local', KEY_SENT, list0.filter(function (s) { return s.ref !== failed.ref; }));
    restoreDraft(); syncPhotoHints(); hadServerErrors.focus();
  }

  /* Order number may be passed in the link, e.g. from an email. Only the number is read, nothing else. */
  try {
    var qp = new URLSearchParams(window.location.search).get('order');
    var orderEl = $('#mv-rr-order');
    if (qp && orderEl && !orderEl.value) orderEl.value = qp.replace(/[^A-Za-z0-9#\-]/g, '').slice(0, 30);
  } catch (e) {}

  var recvEl = $('#mv-rr-received');
  if (recvEl) { var t0 = new Date(); recvEl.max = t0.getFullYear() + '-' + ('0' + (t0.getMonth() + 1)).slice(-2) + '-' + ('0' + t0.getDate()).slice(-2); }

  form.addEventListener('submit', function (e) {
    if (submitting) { e.preventDefault(); return; }
    if (!validate()) { e.preventDefault(); return; }
    var items = collect();
    var order = $('#mv-rr-order').value.trim();
    var fp = fingerprint(order, items);
    var sent = store('local', KEY_SENT) || [];
    var cutoff = Date.now() - 30 * 24 * 3600 * 1000;
    sent = sent.filter(function (s) { return s.t > cutoff; });
    var dup = sent.filter(function (s) { return s.fp === fp; })[0];
    if (dup && !dupAcknowledged) {
      e.preventDefault();
      errBox.innerHTML = '<strong>This looks like a request you have already sent.</strong> On this device you sent the same items for this order as reference <strong>' + esc(dup.ref) + '</strong>. We have it and will review it, so there is no need to send it again. If something has changed, press &ldquo;Send anyway&rdquo;.';
      errBox.hidden = false; errBox.focus(); errBox.scrollIntoView({ block: 'center' });
      sendBtn.textContent = 'Send anyway';
      dupAcknowledged = true;
      return;
    }
    var ref = makeRef();
    $('#mv-rr-ref').value = ref;
    var photosYes = $('#mv-rr-photos-yes').checked;
    bodyField.value = buildBody(ref, items, order, photosYes);
    var photoRelevant = faultySelected();
    store('session', KEY_LAST, { ref: ref, order: order, items: items, photoRelevant: photoRelevant });
    store('session', KEY_DRAFT, { name: $('#mv-rr-name').value, email: $('#mv-rr-email').value, order: order, received: $('#mv-rr-received').value, details: $('#mv-rr-details').value, items: items, photos: photosYes });
    sent.push({ fp: fp, ref: ref, t: Date.now() });
    store('local', KEY_SENT, sent);
    submitting = true;
    sendBtn.disabled = true;
    sendBtn.setAttribute('aria-disabled', 'true');
    sendBtn.textContent = 'Sending…';
    /* If the page is restored from the back/forward cache, allow trying again. */
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { submitting = false; sendBtn.disabled = false; sendBtn.removeAttribute('aria-disabled'); sendBtn.textContent = 'Send return request'; } }, { once: true });
  });
})();
